export enum PermissionGroup {
    OwnTeam = 'own_team_management',
    OtherInternalTeam = 'other_internal_team_management',
    OtherExternalTeam = 'other_external_team_management',
    Brand = 'brand',
    CampaignManagement = 'campaign_management',
    TemplatedCampaign = 'templated_campaign_management',
    CampaignStatusControl = 'campaign_status_control',
    Submission = 'campaign_submission',
    // TODO replace it when backend in ready
    Banner = 'banner',
    Payout = 'payout_management',
    AmbassadorsManagement = 'ambassador_management',
}

export enum Brand {
    CreateEdit = 'brand::create::edit',
    Delete = 'brand::delete',
}

export enum OwnTeamManagement {
    AssignRoles = 'own_team_management::manage_members::assign_roles',
    ManageRoles = 'own_team_management::manage_roles',
    CreateTeam = 'own_team_management::create_team',
}

export enum OtherInternalTeamManagement {
    AssignRoles = 'other_internal_team_management::add::remove::assign_roles',
    ManageRoles = 'other_internal_team_management::manage_roles',
}

export enum OtherExternalTeamManagement {
    AssignRoles = 'other_external_team_management::add::remove::assign_roles',
    ManageRoles = 'other_external_team_management::manage_roles',
}
export enum CampaignManagement {
    LiveCampaignEditDeadlines = 'live_campaign_management::edit_deadlines',
    LiveCampaignEditBriefs = 'live_campaign_management::edit_briefs',
    CreateAndEditBriefsForInternal = 'campaign_management::create_and_edit_briefs_for_internal',
    CreateAndEditBriefsForExternal = 'campaign_management::create_and_edit_briefs_for_external',
    ShowPrivateCampaignBudget = 'campaign_management::show_private_campaign_budgets',
    EditDefaultTags = 'campaign_management::edit_default_tags',
}
export enum TemplatedCampaignManagement {
    CreateAndEditBriefsForInternal = 'templated_campaign_management::create_and_edit_briefs_for_internal',
    CreateAndEditBriefsForExternal = 'templated_campaign_management::create_and_edit_briefs_for_external',
    LiveCampaignEditBriefsAndDeadlines = 'templated_campaign_management::edit_live_campaign_briefs_and_deadlines',
}
export enum CampaignStatusControl {
    ReviewCampaign = 'campaign_management::review',
    LaunchCampaign = 'campaign_management::launch',
    CloseCampaign = 'campaign_management::close',
    PayCampaign = 'campaign_management::pay',
}
export enum Payout {
    UpdatePayouts = 'payout_management::update',
    PayPartiposters = 'payout_management::pay',
    DisqualifyPartiposters = 'payout_management::disqualify',
}
//TODO replace code when backend is ready
export enum CampaignSubmission {
    ReviewDirectly = 'campaign_submission::review_directly',
    ReviewIndirectly = 'campaign_submission::review_indirectly',
    ReviewUrlOrScreenshotStep = 'campaign_submission::review_url_or_screenshot_step',
    ReviewEngagementStep = 'campaign_submission::review_engagement_step',
    EditPostSchedule = 'campaign_submission::edit_post_schedule',
    ManageTag = 'app_user::manage_tag',
    ApproveRegistrationAndManageWaitList = 'registration_submission::manage',
    MoveRegistrationToPendingApproval = 'registration_submission::revert_to_pending',
    ReviewCaptionWithAi = 'campaign_submission::review_caption_with_ai',
}
export enum Banner {
    CreateBanner = 'create_banner',
    DisableBanner = 'disable_banner',
}

export enum Ambassador {
    AddRemoveFavourite = 'ambassador_management::add_and_remove_favorite_users',
}

/**
 * List of all available permissions in CM
 */
export const AvailablePermissions = [
    OwnTeamManagement.AssignRoles,
    OwnTeamManagement.ManageRoles,
    OwnTeamManagement.CreateTeam,
    OtherInternalTeamManagement.AssignRoles,
    OtherExternalTeamManagement.AssignRoles,
    OtherInternalTeamManagement.ManageRoles,
    OtherExternalTeamManagement.ManageRoles,
    Brand.CreateEdit,
    Brand.Delete,
    CampaignManagement.ShowPrivateCampaignBudget,
    CampaignManagement.LiveCampaignEditDeadlines,
    CampaignManagement.LiveCampaignEditBriefs,
    CampaignManagement.CreateAndEditBriefsForExternal,
    CampaignManagement.CreateAndEditBriefsForInternal,
    CampaignManagement.EditDefaultTags,
    TemplatedCampaignManagement.CreateAndEditBriefsForInternal,
    TemplatedCampaignManagement.CreateAndEditBriefsForExternal,
    TemplatedCampaignManagement.LiveCampaignEditBriefsAndDeadlines,
    CampaignStatusControl.CloseCampaign,
    CampaignStatusControl.LaunchCampaign,
    CampaignStatusControl.ReviewCampaign,
    CampaignStatusControl.PayCampaign,
    CampaignSubmission.ApproveRegistrationAndManageWaitList,
    CampaignSubmission.MoveRegistrationToPendingApproval,
    CampaignSubmission.ReviewDirectly,
    CampaignSubmission.ReviewIndirectly,
    CampaignSubmission.ReviewUrlOrScreenshotStep,
    CampaignSubmission.ReviewEngagementStep,
    CampaignSubmission.ManageTag,
    CampaignSubmission.EditPostSchedule,
    CampaignSubmission.ReviewCaptionWithAi,
    Banner.CreateBanner,
    Banner.DisableBanner,
    Payout.UpdatePayouts,
    Payout.PayPartiposters,
    Payout.DisqualifyPartiposters,
    Ambassador.AddRemoveFavourite,
]
